import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import App from "./App";
import store from "store";
import * as serviceWorker from "./serviceWorker";
import history from "./routers/history";
import { posthog } from "posthog-js";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { LOCAL_STORAGE_AUTH_KEY } from "./config/constants";

console.log(
  `${process.env.REACT_APP_NAME} version ${process.env.REACT_APP_VERSION}`
);


if (process.env.NODE_ENV === "production") {
  posthog.init("phc_44S3vavruc8Pdb75kP1AxBxBSugjG3rlyUMVcEkAHxr");
  Sentry.init({
    dsn: "https://ccb72de757b34a55850c620363220b16@o373641.ingest.sentry.io/5244114",
    release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
    environment: `${process.env.REACT_APP_ENV}`,
    ignoreErrors: [
      "TypeError: Failed to fetch",
      "TypeError: NetworkError when attempting to fetch resource.",
      "TypeError: Cancelled",
      "TypeError: cancelado",
      "Failed to fetch",
    ],
    integrations: [
      new Integrations.CaptureConsole({
        levels: ["error"],
      }),
      new posthog.SentryIntegration(posthog, "alemhealth-ql", "5191013"),
    ],
  });

  const user = store.get(LOCAL_STORAGE_AUTH_KEY.USER_PROFILE);
  if (user) {
    Sentry.configureScope(function (scope) {
      scope.setTag("userEmail", user.email);
    });
    posthog.identify({
      name: user?.name? user?.name : user?.nickname,
      email: user?.email,
    })
  }
}


ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);
// registerServiceWorker()
serviceWorker.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
